import React from "react";
import { useLocation } from "react-router-dom";
import MarketingNav from "@/components/MarketingNav";
import Footer from "@/components/Footer";
import Seo from "@/components/Seo";

const LegalLayout = ({ title, subtitle, children }) => {
  const location = useLocation();
  return (
  <div className="bg-white min-h-screen flex flex-col">
    <Seo title={title} description={subtitle || `${title} — TradeOff, takeoff & billing for UK subcontractors.`} path={location.pathname} />
    <MarketingNav />
    <div className="border-b border-slate-200 bg-slate-50">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12">
        <h1 className="font-display text-4xl font-bold text-navy">{title}</h1>
        {subtitle && <p className="mt-2 text-slate-500 text-sm">{subtitle}</p>}
      </div>
    </div>
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12 flex-1 legal-prose w-full">{children}</div>
    <Footer />
  </div>
  );
};

export default LegalLayout;
